import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { PromocodeBatch } from "@modules/promocodeBatches/types";

import { ListPromocodeBatchesQueryFilters } from "./types";

export async function getPromocodeBatchesService(filters?: ListPromocodeBatchesQueryFilters): Promise<PromocodeBatch[]> {
  try {
    const { data } = await api.get<ApiResponse<PromocodeBatch>>(`v1/promocode_batch_admin/`, {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        search: filters?.search,
        ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching promocodes:", error);
    throw error;
  }
}
